import { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";

import { BsSearch } from "react-icons/bs";

const SearchHeader = ({ value, setSearchText, ...props }) => {
  const inputRef = useRef(null);

  // Local input mirrors what the user is typing so the field stays
  // responsive even while we debounce the parent's setSearchText. Without
  // this, every keystroke fired an API call and a slow earlier response
  // could clobber a faster later one — making the table look "stuck" until
  // the user typed an extra character (e.g. a trailing space) that issued
  // one final request whose result finally landed last.
  const [internalValue, setInternalValue] = useState(value ?? "");
  const lastEmittedRef = useRef(value ?? "");

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  // Keep local state in sync when the parent resets/changes value externally
  // (e.g. tab switch, clear filters). Skip echoes of values we just emitted
  // so the user's in-flight keystrokes are not overwritten.
  useEffect(() => {
    const incoming = value ?? "";
    if (incoming !== lastEmittedRef.current) {
      setInternalValue(incoming);
      lastEmittedRef.current = incoming;
    }
  }, [value]);

  useEffect(() => {
    if (internalValue === lastEmittedRef.current) return;
    const timerId = setTimeout(() => {
      lastEmittedRef.current = internalValue;
      setSearchText(internalValue);
    }, 500);
    return () => clearTimeout(timerId);
  }, [internalValue, setSearchText]);

  return (
    <Form.Group className="position-relative">
      <BsSearch className="position-absolute top-50 me-3 end-0 translate-middle-y" />
      <Form.Control
        type="text"
        ref={inputRef}
        placeholder="Search..."
        value={internalValue}
        onChange={(e) => setInternalValue(e.target.value)}
        {...props}
      />
    </Form.Group>
  );
};

export default SearchHeader;
